module.exports = __webpack_public_path__ + "static/media/marisa2.c181b20c.mp3";